<template>
  <v-form ref="form" v-on:submit.prevent v-model="valid">
    <p>Тип клиента</p>
    <v-radio-group :rules="[rules.required('')]" v-model="company_type" row>
      <v-radio color="#88BD1F" label="ИП" value="IP"></v-radio>
      <v-radio color="#88BD1F" label="ООО" value="UL"></v-radio>
    </v-radio-group>

    <v-row no-gutters>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[А-Яа-яёЁ-]/"
          :rules="[rules.required('Введите фамилию контактного лица')]"
          v-model="person_surname"
          label="Фамилия контактного лица"
        />
      </v-col>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[А-Яа-яёЁ]/"
          :rules="[rules.required('Введите имя контактного лица')]"
          v-model="person_firstname"
          label="Имя контактного лица"
        />
      </v-col>
      <v-col cols="12" class="font--color_light font--label mb-9">
        <MaskedTextField
          :pattern="/[\sА-Яа-яёЁ]/"
          :rules="[rules.required('Введите отчество контактного лица')]"
          v-model="person_middlename"
          label="Отчество контактного лица"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" class="font--color_light font--label pr-sm-2"
      >
        <v-text-field
          :rules="[rules.required('Введите Номер телефона'), rules.phone]"
          outlined
          required
          style="text-align: center"
          label="Телефон контактного лица"
          name="phone"
          type="text"
          v-model="phone"
          dense
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="font--color_light font--label">
        <v-text-field
          :rules="[rules.email]"
          v-model="email"
          outlined
          label="Электронная почта"
          dense
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="font--color_light font--label">
        <v-textarea counter="2048" :rules="[rules.comment]" label="Комментарий" rows="3" outlined
                    v-model="comment"></v-textarea>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="sendBid" :disabled="!valid">Создать заявку</v-btn>
  </v-form>
</template>
<script>
import { mask } from "vue-the-mask";
import { email as ruleEmail } from "@/utils/rules";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import MaskedTextField from "@/components/common/MaskedTextField";
import formatPhone from "../../utils/formatPhone";

export default {
  components: { MaskedTextField },

  directives: { mask },
  data() {
    return {
      tooltipText: "Здесь будет текст про то что сюда можно вписать",
      valid: false,
      rules: {
        required: (msg) => (v) => !!v || msg,
        email: v => !v || ruleEmail(v),
        phone: (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона",
        comment: (v) => !v || v.length <= 2048 || "Максимум 2048 символов",
      },
    };
  },
  computed: {
    ...mapGetters("common", ["errdesc"]),
    ...mapState({
      statePhone: (state) => state.bid.person_phone,
      stateEmail: (state) => state.bid.person_email,
      stateFirstname: (state) => state.bid.person_firstname,
      stateSurname: (state) => state.bid.person_surname,
      stateMiddlename: (state) => state.bid.person_middlename,
      stateComment: (state) => state.bid.comment,
      companyType: (state) => state.bid.company_type,
      showNewBid: (state) => state.common.showNewBid,
    }),
    phone: {
      get() {
        return this.statePhone || "";
      },
      set(newVal) {
        const _value = formatPhone(newVal);
        this.set({ type: "person_phone", value: _value });
      },
    },
    email: {
      get() {
        return this.stateEmail;
      },
      set(value) {
        this.set({ type: "person_email", value });
      },
    },
    person_firstname: {
      get() {
        return this.stateFirstname;
      },
      set(value) {
        this.set({ type: "person_firstname", value });
      },
    },
    person_surname: {
      get() {
        return this.stateSurname;
      },
      set(value) {
        this.set({ type: "person_surname", value });
      },
    },
    person_middlename: {
      get() {
        return this.stateMiddlename;
      },
      set(value) {
        this.set({ type: "person_middlename", value });
      },
    },
    comment: {
      get() {
        return this.stateComment;
      },
      set(value) {
        this.set({ type: "comment", value });
      },
    },
    company_type: {
      get() {
        return this.companyType;
      },
      set(value) {
        this.set({ type: "company_type", value });
      },
    },
  },
  watch: {
    showNewBid(show) {
      if (!show) {
        this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    ...mapMutations("bid", ["set"]),
    ...mapActions("bid", ["regBusiness"]),
    sendBid() {
      this.regBusiness();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
<style scoped>
</style>
